<template>
  <div>
    <v-menu
      v-model="menu"
      offset-y
      left
      :close-on-content-click="false"
      nudge-bottom="8"
    >
      <template #activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on">
          <v-icon size="25" color="#757575">$DotsThree</v-icon>
        </v-btn>
      </template>

      <v-card class="card-visiveis" flat>
        <div class="header-visiveis">
          <div class="titulo-visiveis">Configuração de colunas</div>

          <v-btn icon small class="close-btn" @click="menu = false">
            <v-icon size="18">mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="pesquisa-div">
          <v-text-field
            v-model="search"
            dense
            solo
            flat
            hide-details
            placeholder="Buscar uma coluna..."
            class="pesquisa-input"
          />
        </div>

        <div class="wrapper-secoes">
          <div class="block-secoes">
            <div class="header-secoes">
              <span class="titulo-secoes">Visíveis na tabela</span>
              <button
                type="button"
                class="action-secoes"
                @click="esconderTodas"
              >
                Ocultar todas
              </button>
            </div>

            <div v-if="colunas_visiveis_filtradas.length" class="lista-colunas">
              <div
                v-for="item in colunas_visiveis_filtradas"
                :key="item.label"
                class="item-coluna"
                :class="linhaClasses(item.originalIndex)"
                :draggable="item.reordenar"
                @dragstart="onDragStart(item.originalIndex)"
                @dragover.prevent="onDragOver(item.originalIndex)"
                @drop.prevent="onDrop(item.originalIndex)"
                @dragend="onDragEnd"
              >
                <div class="main-coluna">
                  <v-icon
                    color="#0f172a"
                    size="25"
                    class="drag-icon"
                    :class="{ 'drag-icon--disabled': item.reordenar === false }"
                  >
                    $DotsSixVertical
                  </v-icon>

                  <span
                    :class="{ 'drag-icon--disabled': item.reordenar === false }"
                    class="name-coluna"
                  >
                    {{ item.label }}
                  </span>
                </div>

                <v-btn
                  icon
                  small
                  class="eye-btn"
                  :class="{
                    'item-coluna--locked': item.ocultar === false
                  }"
                  @click.stop="item.visivel = !item.visivel"
                >
                  <v-icon size="18" color="#4075FF">
                    mdi-eye-outline
                  </v-icon>
                </v-btn>
              </div>
            </div>

            <div v-else class="empty-state">
              Nenhuma coluna visível
            </div>
          </div>

          <div class="block-secoes block-secoes--last">
            <div class="header-secoes">
              <span class="titulo-secoes">Ocultas na tabela</span>
              <button
                type="button"
                class="action-secoes"
                @click="mostrarTodas"
              >
                Mostrar todas
              </button>
            </div>

            <div v-if="colunas_invisiveis_filtradas.length" class="lista-colunas">
              <div
                v-for="item in colunas_invisiveis_filtradas"
                :key="item.label"
                class="item-coluna item-coluna--muted"
                :class="linhaClasses(item.originalIndex)"
                :draggable="item.reordenar"
                @dragstart="onDragStart(item.originalIndex)"
                @dragover.prevent="onDragOver(item.originalIndex)"
                @drop.prevent="onDrop(item.originalIndex)"
                @dragend="onDragEnd"
              >
                <div class="main-coluna">
                  <v-icon size="25" class="drag-icon">
                    $DotsSixVertical
                  </v-icon>

                  <span class="name-coluna">{{ item.label }}</span>
                </div>

                <v-btn
                  icon
                  small
                  class="eye-btn"
                  @click.stop="item.visivel = !item.visivel"
                >
                  <v-icon size="18" color="#94A3B8">
                    mdi-eye-off-outline
                  </v-icon>
                </v-btn>
              </div>
            </div>

            <div v-else class="empty-state">
              Nenhuma coluna oculta
            </div>
          </div>
        </div>

        <div class="footer">
          <span class="footer-text">
            {{ visiveis_contador }} de {{ colunas.length }} colunas visíveis
          </span>

          <v-btn
            :color="ID_UNICO_PREFERENCIA_NULO ? '#8d9299' : '#2563FF'"
            dark
            depressed
            rounded
            class="text-none save-btn"
            :class="{
              'cursor-default' : ID_UNICO_PREFERENCIA_NULO
            }"
            @click="salvar"
          >
            Salvar
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { logout } from "@/helpers";

import api from "@/api/api";
import store from "@/store";

const props = defineProps({
  id_unico_preferencia: String,
  colunas: Array,
});

const ID_UNICO_PREFERENCIA_NULO = computed(() => props.id_unico_preferencia === null || props.id_unico_preferencia.trim().length <= 0);

onMounted(validarPropsPersonalizacaoColunas);

function validarPropsPersonalizacaoColunas() {
  if (!ID_UNICO_PREFERENCIA_NULO.value) {
    return;
  }

  throw new Error(
    "As props 'idUniquePreference' e 'showColumnCustom' devem ser informadas juntas."
  );
}

const items = computed(() => store.state.tabela_compra.items);

watch(items, () => { buscar('update'); }, { deep: true });

const emit = defineEmits(['update:colunas']);
onMounted(buscar);

const disabledColumnsCustomComputed = computed(() => props.colunas.filter(item => !!item.customColumnDisabled))

const colunas = ref(
  props.colunas
    .map((i, index) => {
      const customColumnDisabled = disabledColumnsCustomComputed.value.some(item => item.value === i.value);

      return {
        id: i.value,
        label: i.text,
        visivel: true,
        ocultar: !customColumnDisabled,
        reordenar: !customColumnDisabled,
        originalIndex: index,
      };
    })
);

const menu = ref(false);
const search = ref('');
const draggedIndex = ref(null);
const dragOverIndex = ref(null);

const txt_pesquisa_termo_normalizado = computed(() => search.value.trim().toLowerCase());

const visiveis_contador = computed(() => {
  return colunas.value.filter(item => item.visivel).length;
});

const colunas_visiveis = computed(() => {
  return colunas.value.filter(item => item.visivel && item.id !== 'data-table-select');
});

const colunas_invisiveis = computed(() => {
  return colunas.value.filter(item => !item.visivel && item.id !== 'data-table-select');
});

const colunas_visiveis_filtradas = computed(() => {
  if (!txt_pesquisa_termo_normalizado.value) {
    return colunas_visiveis.value;
  }

  return colunas_visiveis.value.filter(item =>
    item.label.toLowerCase().includes(txt_pesquisa_termo_normalizado.value)
  );
});

const colunas_invisiveis_filtradas = computed(() => {
  if (!txt_pesquisa_termo_normalizado.value) {
    return colunas_invisiveis.value;
  }

  return colunas_invisiveis.value.filter(item =>
    item.label.toLowerCase().includes(txt_pesquisa_termo_normalizado.value)
  );
});

function esconderTodas() {
  colunas.value = colunas.value.map(item => ({
    ...item,
    visivel: !item.ocultar,
  }));
}

function mostrarTodas() {
  colunas.value = colunas.value.map(item => ({
    ...item,
    visivel: true,
  }));
}

function linhaClasses(index) {
  return {
    'is-dragging': draggedIndex.value === index,
    'is-drag-over': dragOverIndex.value === index && draggedIndex.value !== index,
  };
}

function onDragStart(index) {
  const coluna = colunas.value[index];

  if (!coluna.reordenar) return;

  draggedIndex.value = index;
}

function onDragOver(index) {
  dragOverIndex.value = index;
}

function onDrop(index) {
  if (draggedIndex.value === null || draggedIndex.value === index) {
    onDragEnd();
    return;
  }

  const updated = [...colunas.value];
  const draggedItem = updated[draggedIndex.value];
  const targetItem = updated[index];

  if (!draggedItem.reordenar) {
    onDragEnd();
    return;
  }

  if (!targetItem.reordenar) {
    onDragEnd();
    return;
  }

  updated.splice(draggedIndex.value, 1);
  updated.splice(index, 0, draggedItem);

  colunas.value = updated;

  onDragEnd();
}

function onDragEnd() {
  draggedIndex.value = null;
  dragOverIndex.value = null;
}

function getFixedStartIds() {
  if (!disabledColumnsCustomComputed.value.length) return [];
  const indexSugestao = disabledColumnsCustomComputed.value.indexOf('sugestao');

  if (indexSugestao === -1) return disabledColumnsCustomComputed.value;
  return disabledColumnsCustomComputed.value.slice(0, indexSugestao);
}

function getFixedEndIds() {
  if (!disabledColumnsCustomComputed.value.length) return [];
  const indexSugestao = disabledColumnsCustomComputed.value.indexOf('sugestao');

  if (indexSugestao === -1) return [];
  return disabledColumnsCustomComputed.value.slice(indexSugestao);
}

function buscar(tipo_evento = 'init') {
  if (ID_UNICO_PREFERENCIA_NULO.value) {
    return;
  }

  const id_referencia = props.id_unico_preferencia + '_COLUMN_CUSTOM';

  api.get(`preferencias/usuarios/${localStorage.id}/tabelas/${id_referencia}`)
  .then(resposta => {
    if (resposta.data.preferencia) {
      const colunas_preferencias = JSON.parse(resposta.data.preferencia.preferencias);
      const ids = new Set(colunas_preferencias.map(i => i.id));

      colunas.value = colunas.value.map(coluna => ({
        ...coluna,
        visivel: ids.has(coluna.id)
      }));

      emit("update:colunas", { colunas: colunas_visiveis.value, tipo: tipo_evento });
    }
  })
  .catch(logout)
}

function salvar() {
  if (ID_UNICO_PREFERENCIA_NULO.value) {
    return;
  }

  const id_referencia = props.id_unico_preferencia + '_COLUMN_CUSTOM';

  api.post(`preferencias/usuarios/${localStorage.id}/tabelas/${id_referencia}`, colunas_visiveis.value)
  .then(() => {
    emit("update:colunas", { colunas: colunas_visiveis.value, tipo: 'update' });
    menu.value = false;
  })
  .catch(logout)
}
</script>

<style scoped>
.card-visiveis {
  background: #ffffff;
  border: 1px solid #e5eaf1;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12) !important;
  overflow: hidden;
  min-width: 360px;
  width: 100%;
}

.header-visiveis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 10px;
}

.titulo-visiveis {
  font-size: 16px;
  font-weight: 500;
  color: #0f172a;
}

.close-btn {
  margin-right: -4px;
}

.pesquisa-div {
  padding: 0 16px 12px;
}

.pesquisa-input :deep(.v-input__control) {
  min-height: 38px !important;
}

.pesquisa-input :deep(.v-input__slot) {
  min-height: 38px !important;
  border-radius: 10px !important;
  background: #f8fafc !important;
  box-shadow: inset 0 0 0 1px #d8e1eb !important;
  padding: 0 12px !important;
}

.pesquisa-input :deep(input) {
  font-size: 14px;
  color: #334155;
}

.wrapper-secoes {
  max-height: 320px;
  overflow-y: auto;
  padding-bottom: 4px;
}

.block-secoes {
  padding: 4px 0 0;
}

.block-secoes--last {
  padding-top: 8px;
}

.header-secoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}

.titulo-secoes {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.action-secoes {
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: #4075FF;
  cursor: pointer;
}

.action-secoes:hover {
  opacity: 0.85;
}

.lista-colunas {
  padding: 0 8px;
}

.item-coluna {
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 8px 0 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  transition: background-color 0.18s ease, opacity 0.18s ease;
}

.item-coluna:hover {
  background: #f1f5f9;
}

.item-coluna.is-dragging {
  opacity: 0.5;
}

.item-coluna.is-drag-over {
  background: #e7f0fd;
}

.main-coluna {
  min-width: 0;
  flex: 1;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.drag-icon {
  color: #94a3b8;
  cursor: grab;
  flex-shrink: 0;
}

.item-coluna--muted .name-coluna {
  color: #64748b;
}

.name-coluna {
  font-size: 14px;
  color: #0f172a;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eye-btn {
  flex-shrink: 0;
}

.empty-state {
  padding: 8px 16px 14px;
  font-size: 13px;
  color: #94a3b8;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 16px;
  border-top: 1px solid #e8edf3;
  background: #fff;
}

.footer-text {
  font-size: 13px;
  color: #64748b;
}

.save-btn {
  min-width: 96px;
  height: 34px !important;
  border-radius: 8px !important;
  letter-spacing: 0;
  font-weight: 500;
}

.drag-icon--disabled {
  opacity: 0.35;
  cursor: default;
}

.item-coluna--locked {
  opacity: 0.6;
}
</style>
